import { useCallback, useEffect, useState } from 'react'

import { Dayjs } from 'dayjs'

import { LogExercices, NewLog, PatchableKeys } from '../types'

const INITIAL_EXERCISE: LogExercices = {
  category: [],
  gender: null,
  routine: null,
  exercise: { title: '', url: '' },
}

type AudioRef = { title: string; url: string; path?: string }
type AudioValue = AudioRef[] | undefined
type AudioSetter = AudioRef | AudioRef[] | undefined
type AudioUpdater = (prev: AudioValue) => AudioValue

export function useLogForm(initial: NewLog) {
  const [state, setState] = useState<NewLog>(initial)

  useEffect(() => {
    if (initial?.uid !== state?.uid) setState(initial)
  }, [initial?.uid])

  const patch = useCallback((key: PatchableKeys, value: string) => {
    setState((prev) => ({ ...prev, [key]: value }))
  }, [])

  const setDate = useCallback((date: Dayjs | null) => {
    if (!date) return
    setState((prev) => ({ ...prev, date: date.format('YYYY-MM-DD') }))
  }, [])

  // const setAudio = useCallback((file?: { title: string; url: string }) => {
  //   setState((prev) => {
  //     if (!file) {
  //       delete prev.audio
  //       return prev
  //     }
  //     return { ...prev, audio: file }
  //   })
  // }, [])
  const setAudio = useCallback((next: AudioSetter | AudioUpdater) => {
    setState((prev) => {
      const curr = (prev.audio ?? undefined) as AudioValue
      const resolved: AudioValue =
        typeof next === 'function'
          ? (next as AudioUpdater)(curr)
          : Array.isArray(next)
            ? next
            : next
              ? [next]
              : undefined
      const normalized =
        resolved && resolved.length === 0 ? undefined : resolved
      return { ...prev, audio: normalized }
    })
  }, [])

  const addExercise = useCallback(() => {
    setState((prev) => ({
      ...prev,
      exercises: [...(prev.exercises ?? []), INITIAL_EXERCISE],
    }))
  }, [])

  const replace = useCallback((next: NewLog) => setState(next), [])

  return {
    state,
    patch,
    setDate,
    setAudio,
    addExercise,
    replace,
  }
}
